// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vFNQGoSmDYt4Zx {
  margin-bottom: 52px;
}
.vFNQGoSmDYt4Zx p {
  size: 16px;
}
.vFNQGoSmDYt4Zx img {
  max-width: 100%;
}
.I_fgbgwGIEcF8C {
  margin-top: 28px;
  color: var(--ds-text, #172b4d);
  font-size: 20px;
  letter-spacing: -0.008em;
  line-height: 24px;
  font-weight: 600;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"markdownContainer": `vFNQGoSmDYt4Zx`,
	"header": `I_fgbgwGIEcF8C`
};
export default ___CSS_LOADER_EXPORT___;
